import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../utils/tokenService";
import { FaFileAlt } from "react-icons/fa";
import moment from "moment-timezone";

const ClientPaySlips = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(
    moment().tz("Asia/Kolkata").month()
  );
  const [selectedYear, setSelectedYear] = useState(
    moment().tz("Asia/Kolkata").year()
  );
  const navigate = useNavigate();
  const months = moment.months();
  const yearRange = useMemo(() => {
    const startYear = moment().tz("Asia/Kolkata").year() - 2;
    return Array.from({ length: 5 }, (_, idx) => startYear + idx);
  }, []);

  useEffect(() => {
    const loadEmployees = async () => {
      setLoading(true);
      setError("");
      try {
        const token = await getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/client/offer-letters`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              month: selectedMonth + 1,
              year: selectedYear,
            },
          }
        );
        setEmployees(response.data?.employees || []);
      } catch (err) {
        console.error("Failed to load employees for pay slips:", err);
        setError("Could not load employee roster. Please try again.");
        toast.error("Unable to load pay slip data right now.");
      } finally {
        setLoading(false);
      }
    };

    loadEmployees();
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    if (!selectedEmployeeId && employees.length) {
      setSelectedEmployeeId(employees[0]._id);
    }
  }, [employees, selectedEmployeeId]);

  if (loading) {
    return <div className="p-4">Loading pay slips...</div>;
  }

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-3 gap-3">
        <div>
          <h4 className="mb-0">Pay Slips</h4>
          <small className="text-muted">{employees.length} employees</small>
        </div>
        <div className="d-flex gap-2">
          <label className="d-flex flex-column small">
            Month
            <select
              className="form-select form-select-sm"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
            >
              {months.map((month, idx) => (
                <option key={month} value={idx}>
                  {month}
                </option>
              ))}
            </select>
          </label>
          <label className="d-flex flex-column small">
            Year
            <select
              className="form-select form-select-sm"
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {yearRange.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </label>
        </div>
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => navigate("/client_dashboard")}
        >
          Back to dashboard
        </button>
      </div>
      {error && <div className="alert alert-warning">{error}</div>}
      {!employees.length ? (
        <p className="text-muted">No employees found for this client.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th>Employee ID</th>
                <th>Name</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Pay Slip</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp._id}>
                  <td>{emp.employeeId ? `CMPL${emp.employeeId}` : "N/A"}</td>
                  <td>{emp.full_Name || "Employee"}</td>
                  <td>{emp.contact || "-"}</td>
                  <td>{emp.email || "-"}</td>
                  <td>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        navigate(
                          `/client_dashboard/pay-slip/${emp._id}?month=${
                            selectedMonth + 1
                          }&year=${selectedYear}`
                        )
                      }
                    >
                      <FaFileAlt className="me-1" />
                      View
                    </button>
                    {selectedEmployeeId === emp._id ? (
                      <div className="small text-success mt-1">
                        Viewing payslip
                      </div>
                    ) : (
                      <div className="small text-muted mt-1">
                        Click to view payslip
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ClientPaySlips;
